export default "# Tabs 标签页\r\n\r\n分隔内容上有关联但属于不同类别的数据集合。\r\n\r\n\r\n## 何时使用\r\n\r\n- ...";